import React, { useEffect, useState } from "react";
import { getAutoCountries } from '../../Services/API';
import $, { param } from "jquery";
import "jquery-ui-dist/jquery-ui";
import "jquery-ui-dist/jquery-ui.css";
import { RaiseInsuranceEnquiry } from '../../Services/EnquiryApi'

const InsuranceSearch = () => {

  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState("");
  const [travelDays, setTravelDays] = useState(0);

  // Add traveller
  const [showDropdown, setShowDropdown] = useState(false);
  const [adults, setAdults] = useState(2);
  const [children, setChildren] = useState(0);
  const [infant, setInfant] = useState(0);
  const totalTravellers = adults + children + infant;

  const [travelType, setTravelType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [enquiryMessage, setEnquiryMessage] = useState("");
  const [enquiryStatus, setEnquiryStatus] = useState(false);
  // Add traveller end
  const [showPopup, setShowPopup] = useState(false);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    const fetchCountries = async () => {
      const data = await getAutoCountries();
      console.log("Fetched countries:", data);

      const countryList = Array.isArray(data?.countries) ? data.countries : [];
      setCountries(countryList);

      //Default to India if available
      const india = countryList.find(
        (c) => c.countryCode?.toLowerCase() === "in"
      );
      if (india) setSelectedCountry(india.countryCode);
    };

    fetchCountries();
  }, []);


  // Helper function to calculate days difference
  const calculateDays = () => {
    const start = $("#departureDate").datepicker("getDate");
    const end = $("#returnDate").datepicker("getDate");

    if (start && end) {
      const diffTime = end - start;
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setTravelDays(diffDays >= 0 ? diffDays : 0);
    } else {
      setTravelDays(0);
    }
  };

  // Departure datepicker
  useEffect(() => {
    $("#departureDate").datepicker({
      dateFormat: "dd/mm/yy",
      appendTo: "#dateDisplay",
      minDate: 0,
      maxDate: "+4m", // Limit 4 months ahead
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay").offset();
          const height = $("#dateDisplay").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },
      onSelect: function (dateText) {
      setStartDate(dateText); 
        const date = $(this).datepicker("getDate");
        const day = ("0" + date.getDate()).slice(-2);
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const dayName = date.toLocaleDateString("default", { weekday: "long" });
        $("#dep_dayNum").text(day);
        $("#dep_monthYear").text(`${month}-${year}`);
        $("#dep_dayName").text(dayName);
        calculateDays(); // Recalculate when departure changes
      },
    });
  }, []);

  // Return datepicker
  useEffect(() => {
    $("#returnDate").datepicker({
      dateFormat: "dd/mm/yy",
      appendTo: "#dateDisplay2",
      minDate: 0,
      maxDate: "+4m",
      showAnim: "fadeIn",
      beforeShow: function (input, inst) {
        setTimeout(() => {
          const offset = $("#dateDisplay2").offset();
          const height = $("#dateDisplay2").outerHeight();
          $(inst.dpDiv).css({
            top: offset.top + height + "px",
            left: offset.left + "px",
          });
        }, 0);
      },
      onSelect: function () {
        const date = $(this).datepicker("getDate");
        const day = ("0" + date.getDate()).slice(-2);
        const month = date.toLocaleString("default", { month: "short" });
        const year = date.getFullYear();
        const dayName = date.toLocaleDateString("default", { weekday: "long" });
        $("#ret_dayNum").text(day);
        $("#ret_monthYear").text(`${month}-${year}`);
        $("#ret_dayName").text(dayName);

        calculateDays(); // Recalculate when return changes
      },
    });
  }, []);

  useEffect(() => {
    if (startDate) {
      const [d, m, y] = startDate.split("/");
      const minD = new Date(`${y}-${m}-${d}`);
      $("#returnDate").datepicker("option", "minDate", minD);
    }
  }, [startDate]);



  const handleRaiseRequest = async () => {
    const start = $("#departureDate").datepicker("getDate");
    const end = $("#returnDate").datepicker("getDate");

    if (!selectedCountry) {
      alert("Please select Travelling Country");
      return;
    }

    if (!travelType) {
      alert("Please select Travel Type");
      return;
    }

    if (!start || !end) {
      alert("Please select Start and End dates");
      return;
    }

    const formatDate = (date) => {
      let d = new Date(date);
      //return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
       return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
    };

    const params = {
      companyId: "BerryJourneys",
      travelType: travelType,
      travellingFrom: selectedCountry,
      startDate: formatDate(start),
      endDate: formatDate(end),
      travelDays: travelDays.toString(),
      travellers: (adults + children + infant).toString(),
      noOfAdult: adults,
      noOfChild: children,
      noOfInfant: infant,
      createdBy: "BerryJourneynew@gmail.com",
    };

    try {
      const result = await RaiseInsuranceEnquiry(params);
      if (result.success) {
        setEnquiryMessage(result.message)
        setEnquiryStatus(true);
      }
      else {
        setEnquiryMessage(result.message)
      }
      setStartDate(params.startDate);
      setEndDate(params.endDate);
      setShowPopup(true);

    } catch (error) {
      console.error("API Error:", error);
      alert("Error while creating enquiry!");
    }
  };

  return (
    <>
      <div className='insu_serch'>
        <div className='row'>
          <div className='col-md-6 col-lg-6'>
            <div className='d-flex'>
              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="BusinessTravel"
                    id="BusinessTravel"
                    onChange={(e) => setTravelType(e.target.value)}
                  />
                  <label htmlFor="BusinessTravel" className="form-check-label">Business Travel</label>
                </div></div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="PersonalTravel"
                    id="PersonalTravel"
                    onChange={(e) => setTravelType(e.target.value)}
                  />
                  <label htmlFor="PersonalTravel" className="form-check-label">Personal Travel</label>
                </div>
              </div>

              <div className="travel_mode">
                <div className="form-check form-check-custom form-check-solid">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="travelType"
                    value="GuestTravel"
                    id="GuestTravel"
                    onChange={(e) => setTravelType(e.target.value)}
                  />
                  <label htmlFor="GuestTravel" className="form-check-label">Guest Travel</label>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-6 col-lg-6'>
            <div className='displ_plan'>
              {/*  <div className='show_report'>
                <a className='Anula-plan' data-bs-toggle="modal" data-bs-target="#ViewPlan">View Insurance Plan</a>
             
          </div> */}
            </div>
          </div>
        </div>

        <div className='form_ful'>
          <div className='insurnce_clo_1 trivl'>
            <p className='tl_frm'><i className='fa fa-location-dot'></i> Travelling To</p>
            <select
              className="selct_control"
              value={selectedCountry}
              onChange={(e) => setSelectedCountry(e.target.value)}
            >
              <option value="">Country</option>
              {countries.map((country, index) => (
                <option key={index} value={country.countryCode}>
                  {country.countryName}
                </option>
              ))}
            </select>
          </div>
          <div className="insurnce_clo_1 trivl">
            <p className="tl_frm">
              <i className="fa fa-plane"></i> Travel Type
            </p>
            <select
              className="selct_control"
              value={travelType}
              onChange={(e) => {
                setTravelType(e.target.value);
                setErrors((p) => ({ ...p, travelType: "" }));
              }}
            >
              <option value="">Select</option>
              <option value="Leisure">Leisure</option>
              <option value="Business">Business</option>
              <option value="Student">Student</option>
            </select>
          </div>
          <div className='insurnce_clo_1'>
            <p className='tl_frm'><i className='fa fa-calendar-days'></i> Start Date</p>
            <div
              className="dest_nam"
              id="dateDisplay"
              onClick={() => $("#departureDate").datepicker("show")}
              style={{ cursor: "pointer" }}
            >
              <span id="dep_dayNum" style={{ fontSize: "28px", fontWeight: "bold" }}>
                DD
              </span>{" "}
              <span id="dep_monthYear" style={{ fontSize: "14px" }}>
                MMM-YYYY
              </span>
              <br />
              <span id="dep_dayName">Day</span>
              <input
                type="text"
                id="departureDate"
                style={{ position: "absolute", left: "-9999px" }}
                readOnly
              />
            </div>
          </div>
          <div className='insurnce_clo_1'>
            <p className='tl_frm'><i className='fa fa-calendar-days'></i> End Date</p>
            <div
              className="dest_nam"
              id="dateDisplay2"
              onClick={() => $("#returnDate").datepicker("show")}
              style={{ cursor: "pointer" }}
            >
              <span id="ret_dayNum" style={{ fontSize: "28px", fontWeight: "bold" }}>
                DD
              </span>{" "}
              <span id="ret_monthYear" style={{ fontSize: "14px" }}>
                MMM-YYYY
              </span>
              <br />
              <span id="ret_dayName">Day</span>
              <input
                type="text"
                id="returnDate"
                style={{ position: "absolute", left: "-9999px" }}
                readOnly
              />
            </div>
          </div>
          <div className='insurnce_clo_1'>
            <p className='tl_frm'><i className='fa fa-calendar-days'></i>Travel Days</p>
            <div className="travl_from" style={{ fontSize: "22px", fontWeight: "bold" }}>
              {travelDays}
            </div>
            <p>Days</p>
          </div>
          <div className='insurnce_clo_1 trivl' id='showSelectInsure'>
            <div className='p-0'>
              <p className='tl_frm'><i className='fa fa-users'></i>Travellers</p>
              <div className='travl_from' onClick={() => setShowDropdown(!showDropdown)}> {totalTravellers} Traveller{totalTravellers !== 1 ? "s" : ""}{" "} <img src='/assets/images/down.png' className='down' alt="flight" /></div>
              <p>{adults} Adult{adults !== 1 ? "s" : ""}
                {children > 0 ? `, ${children} Child${children !== 1 ? "ren" : ""}` : ""}
                {infant > 0 ? `, ${infant} Infant${infant !== 1 ? "s" : ""}` : ""}</p>
            </div>

            {/* Dropdown */}
            {showDropdown && (
              <div
                className="insurance dropdown_passenger_in"
                id="toggle_showSelectInsure"

              >
                <div className="traveller-calulate-persons">
                  <div className="passengers">
                    <div className="passengers-types">
                      {/* Adults */}
                      <div className="passengers-type" style={{ marginBottom: "10px" }}>
                        <div className="text">
                          <div className="type-label">
                            <p>Adults</p>
                            <span>12+ yrs</span>
                          </div>
                        </div>
                        <div className="button-set">
                          <select
                            className="form-select form-select-solid"
                            value={adults}
                            onChange={(e) => setAdults(parseInt(e.target.value))}
                          >
                            {[...Array(9)].map((_, i) => (
                              <option key={i + 1} value={i + 1}>
                                {i + 1}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>

                      {/* Children */}
                      <div className="passengers-type">
                        <div className="text">
                          <div className="type-label">
                            <p>Children</p>
                            <span>2 - less than 12 yrs</span>
                          </div>
                        </div>
                        <div className="button-set">
                          <select
                            className="form-select form-select-solid"
                            value={children}
                            onChange={(e) => setChildren(parseInt(e.target.value))}
                          >
                            {[...Array(10)].map((_, i) => (
                              <option key={i} value={i}>
                                {i}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {/* Infant */}
                      <div className="passengers-type">
                        <div className="text">
                          <div className="type-label">
                            <p>Infant</p>
                            <span>Less than 2 yrs</span>
                          </div>
                        </div>
                        <div className="button-set">
                          <select
                            className="form-select form-select-solid"
                            value={infant}
                            onChange={(e) => setInfant(parseInt(e.target.value))}
                          >
                            {[...Array(10)].map((_, i) => (
                              <option key={i} value={i}>
                                {i}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-12 d-flex justify-content-end mt-3">
                    <button
                      className="done_selct btn btn-primary"
                      onClick={() => setShowDropdown(false)}

                    >
                      Done
                    </button>
                  </div>
                </div>
              </div>
            )}

          </div>
          <div className="Rooms_Guests_Serch">
            <button type="button" className="Serch" onClick={handleRaiseRequest}>
              Raise Request
            </button>
          </div>
        </div>
      </div>
      {/* Model Popup  */}
      {showPopup && (
        <div className="popup-overlay" onClick={() => setShowPopup(false)}>
          <div className="popup-box" onClick={(e) => e.stopPropagation()}>
            <h3>{enquiryMessage}</h3>
            {/* {enquiryStatus && (
              <>
                <h5>Your Enquiry Details</h5>
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Travelling To</th>
                      <th>Travel Type</th>
                      <th>Start Date</th>
                      <th>End Date</th>
                      <th>Travel Days</th>
                      <th>Adult</th>
                      <th>Child</th>
                      <th>Infant</th>
                      <th>Total Pax</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{countries.find((c) => c.countryCode === selectedCountry)?.countryName || "-"}</td>
                      <td>{travelType || "-"}</td>
                      <td>{startDate || "-"}</td>
                      <td>{endDate || "-"}</td>
                      <td>{travelDays || "-"}</td>
                      <td>{adults}</td>
                      <td>{children}</td>
                      <td>{infant}</td>
                      <td>{totalTravellers || "-"}</td>

                    </tr>
                  </tbody>
                </table>
              </>
            )} */}

            <button
              onClick={() => {
                setShowPopup(false);
                window.location.reload();
              }}
              className="btn btn-primary"
            >
              Ok
            </button>
          </div>
        </div>
      )}


    </>

  );
};
export default InsuranceSearch;
